import { Component } from '@angular/core';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  public user
  links = []
    events: Event[] = [];
  url
  activeLink
  constructor(
    private authenticationService: AuthenticationService,private storageService: ApiService
  ) { }
 

  ngOnInit() {
    this.user = this.authenticationService.user;
  }
  updateurl(url) {
    this.url = url
  }
}
